import { ReactNode } from "react";
import { Paper } from "@mui/material";
import { useRecordListContext } from "../hooks/useRecordListContext";
import RecordListColumnManagerComponent from "./RecordListColumnManager";
import type { useColumnPreferences } from "../hooks/useColumnPreferences";

export const RelatedListHeader = ({ headerContent, columnPreferences }: { headerContent: ReactNode; columnPreferences: ReturnType<typeof useColumnPreferences> }) => {
    const { readDenied, permissions } = useRecordListContext();
    const readAllowed = !(readDenied || permissions?.read === false);
    // The header carries the tab strip: it must stay so the user can leave a denied tab;
    // only "Manage columns" is hidden when there is nothing readable to manage.
    return (
        <Paper elevation={0} sx={{ mb: 1 }}>
            <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 8, minWidth: 0 }}>
                <div style={{ flex: 1, minWidth: 0 }}>{headerContent}</div>
                {readAllowed && (
                    <RecordListColumnManagerComponent
                        preferences={columnPreferences.preferences}
                        disabled={columnPreferences.isLoading}
                        onSave={columnPreferences.savePreferences}
                    />
                )}
            </div>
        </Paper>
    );
};
